/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */
import React, { Fragment } from "react";
import PropTypes from "prop-types";
import Request from "../../utils/request";
import Swiper from 'swiper/swiper-bundle.min.js'
import utils from "../../utils/utils";
import getStaticUsers from './getStaticUsers';
import 'swiper/swiper.less'
import "./style.less";

function hexColorToRgba(hexColor, opacity) {
  if (!hexColor) {
    return hexColor
  }
  const alphaMaxVal = 1
  hexColor = hexColor.replace("#", "");

  //用于分割16进制色彩通道
  let reg = new RegExp("\\w{1,2}", "g");
  //分割颜色通道
  let rgbaArray255 = hexColor.match(reg);
  rgbaArray255 = rgbaArray255 && rgbaArray255.map((channel, index) => {
    //计算每个通道的10进制值
    let colorVal = parseInt(channel, 16);
    if (index === 3) {
      //这是alpha通道
      return Math.round(colorVal / (255 / alphaMaxVal) * 100) / 100
    }
    return colorVal;
  });
  return `rgb(${rgbaArray255.join(',')},${opacity})`;
}

class PipelinePkRank extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pkData: {
        left: {
          voteCount: 0,
          hasVote: false,
        },
        right: {
          voteCount: 0,
          hasVote: false,
        },
      },
      voteSide: '',
      userHasVote: false,
      voteUserList: [],
      compShow: false
    };
    this.pageId = utils.getPageId();
    this.voteName = this.props.createTime > 1709899200000
      ? this.props['customAttributes']['data-component-id']
      : this.props.config.baseConfig.title;
    this.screenRatio = 1;
    if (typeof window !== 'undefined') {
      this.screenRatio = window.document.body.clientWidth / 375;
    }
    this.voteSwiperRef = null;
    this.progressLeftRef = null;
    this.progressRightRef = null;
    this.swiper = null;
  }

  componentDidMount() {
    this.initPkData();
    this.getVoteUserListData();
  }

  initPkData() {
    const itemList = this.props.config.itemList;
    const pkData = this.state.pkData;
    Object.assign(pkData.left, {}, {
      id: itemList[0].id,
      voteCount: Number(itemList[0].baseNum),
      href: itemList[0].href
    });
    Object.assign(pkData.right, {}, {
      id: itemList[1].id,
      voteCount: Number(itemList[1].baseNum),
      href: itemList[1].href
    });

    this.setState({
      pkData,
    }, () => {
      this.getUserVote();
    })
  }

  getUserVote = () => {
    Request({
      url: 'https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/vote?access_token=znSnA7pxO35wtPBaur',
      method: "get",
      withCredentials: true,
      params: {
        special_id: this.pageId,
        vote_name: this.voteName,
      },
    }).then((res) => {
      if (res.data.status === 0) {
        const pkData = this.state.pkData;
        // 设置用户是否投票信息
        if (res.data.data.has_vote) {
          const voteId = res.data.data.vote_id && res.data.data.vote_id[0];
          pkData.left.hasVote = pkData.left.id == voteId;
          pkData.right.hasVote = pkData.right.id == voteId;
          this.setState({
            userHasVote: true,
            pkData,
            compShow: true
          }, () => {
            this.getVoteCountData();
            this.praiseRef.style.display = "none";
          })
        } else {
          this.setState({
            compShow: true
          }, () => {
            this.getVoteCountData();
          });
        }
      } else {
        this.setState({
          compShow: true
        }, () => {
          this.getVoteCountData();
        });
      }
    }).catch(() => {
      this.setState({
        compShow: true
      }, () => {
        this.getVoteCountData();
      });
    })
  }

  getVoteCountData = () => {
    Request({
      url: 'https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/vote/count?access_token=znSnA7pxO35wtPBaur',
      method: "get",
      withCredentials: true,
      params: {
        special_id: this.pageId,
        vote_name: this.voteName,
      },
    }).then((res) => {
      if (res.data.status === 0) {
        const pkData = this.state.pkData;
        const list = res.data.data.list || [];
        // 计算pk支持人数，附加基础值
        list.forEach(item => {
          if (pkData.left.id == item.vote_id) {
            pkData.left.voteCount = item.cnt + pkData.left.voteCount;
          }
          if (pkData.right.id == item.vote_id) {
            pkData.right.voteCount = item.cnt + pkData.right.voteCount;
          }
        })

        // 计算左右比例
        let leftRate = pkData.left.voteCount / (pkData.left.voteCount + pkData.right.voteCount);
        leftRate = parseInt(leftRate * 10000, 10);
        let rightRate = 10000 - leftRate;

        leftRate = (leftRate / 100) + '%';
        rightRate = (rightRate / 100) + '%';
        pkData.left.rate = leftRate;
        pkData.right.rate = rightRate;
        this.setState({
          pkData,
        }, () => {
          if (this.state.userHasVote) {
            this.progressLeftRef.style.width = leftRate;
            this.progressRightRef.style.width = rightRate;
          }
        });
      }
    })
  }

  getVoteUserListData = () => {
    Request({
      url: 'https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/vote/last?access_token=znSnA7pxO35wtPBaur',
      method: "get",
      withCredentials: true,
      params: {
        special_id: this.pageId,
        vote_name: this.voteName,
        limit: 10,
      },
    }).then((res) => {
      if (res.data.status === 0) {
        const voteNameObj = {};
        this.props.config.itemList.forEach(item => {
          voteNameObj[item.id] = item.name;
        })
        let list = res.data.data.list || [];

        if (list.length < 10) {
          const randomData = this.getVoteDataRandom(10 - list.length);
          list = [...list, ...randomData];
        }

        // 获取投票名称
        list = list.filter(item => {
          if (voteNameObj[item.vote_id]) {
            item.vote_name = voteNameObj[item.vote_id];
            item.user_name = this.getUserName(item.user_name);
            return item
          }
        });

        this.setState({
          voteUserList: list,
        }, () => {
          if (this.state.voteUserList.length > 0) {
            this.swiper = new Swiper(this.voteSwiperRef, {
              allowTouchMove: true,
              direction: 'vertical',
              loop: true,
              pagination: false,
              navigation: false,
              loopAdditionalSlides: 10,
              slidesPerView: 'auto',
              autoplay: {
                delay: 3000,
                disableOnInteraction: false,
              },
            });
          }
        })
      }
    })
  }

  handleVoteAction = async (voteSide) => {
    utils.uploadTrack(this.props);
    const userCookie = await utils.getCookie('u');
    if (userCookie) {
      // 用户投票
      if (this.state.userHasVote) {
        utils.toast('已经投过了', 3000)
        return;
      }
      const pkData = this.state.pkData;
      pkData[voteSide].hasVote = true;
      pkData[voteSide].voteCount += 1;

      // 计算左右比例
      let leftRate = pkData.left.voteCount / (pkData.left.voteCount + pkData.right.voteCount);
      leftRate = parseInt(leftRate * 10000, 10);
      let rightRate = 10000 - leftRate;

      leftRate = (leftRate / 100) + '%';
      rightRate = (rightRate / 100) + '%';
      pkData.left.rate = leftRate;
      pkData.right.rate = rightRate;

      this.setState({
        userHasVote: true,
        pkData,
        voteSide
      }, () => {
        this.progressLeftRef.style.width = leftRate;
        this.progressRightRef.style.width = rightRate;

        import('svgaplayerweb').then((SVGA) => {
          const player = new SVGA.Player(this.praiseRef);
          const parser = new SVGA.Parser(this.praiseRef); // 如果你需要支持 IE6+，那么必须把同样的选择器传给 Parser。
          parser.load('https://static.shihuocdn.cn/admin/files/20240105/f82ca224fbf224ba941d2aa8bec6b969.svga', (videoItem) => {
            player.loops = 1;
            player.setVideoItem(videoItem);
            player.startAnimation();
            player.onFinished(() => {
              this.praiseRef.style.display = "none";
            });
          })
        });
      });

      const voteIds = [Number(pkData[voteSide].id)];

      Request({
        url: 'https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/vote?access_token=znSnA7pxO35wtPBaur',
        method: "post",
        withCredentials: true,
        data: {
          special_id: this.pageId,
          vote_name: this.voteName,
          vote_id: voteIds,
        },
      }).then((res) => {
        if (res.data.status === 0) {
          const voteNameObj = {};
          this.props.config.itemList.forEach(item => {
            voteNameObj[item.id] = item.name;
          })
          // 新增一条投票数据
          const voteResData = res.data.data || {};
          const newItem = {
            id: new Date().valueOf(),
            avatar: voteResData.avatar,
            vote_name: voteNameObj[voteResData.vote_id[0]],
            user_name: this.getUserName(voteResData.user_name),
          };
          this.swiper.appendSlide(`
            <div class="support-item swiper-slide">
              <img class="user-avatar" src="${utils.formatImgUrl(newItem.avatar, this.props.webpSupport)}" alt="" />
              <div class="vote-content">
                ${newItem.user_name}投给了${newItem.vote_name}
              </div>
            </div>
          `)
          this.swiper.update();
        }
      }) 
    } else if (typeof window !== 'undefined'){
      window.Jockey.send('login');
    }
  }

  handleItemClick = (voteSide, index) => {
    const link = this.state.pkData[voteSide].href;
    if (this.props.templateName === 'toufang') {
      utils.handleToufangClick({
        link: link,
        props: this.props,
      })
      return
    }

    if (link) {
      const baseConfig = this.props.config.baseConfig;
      const options = {
        title: baseConfig.title,
        sort: index
      };
      utils.jumpToUrl(this.props.routeParams,link ,link, options, this.state.pkData[voteSide].id, this.props);
    }

  }

  getUserName(username) {  
    if (username.length <= 1) {  
      return username; // 如果昵称长度小于等于1，直接返回原昵称  
    }  
      
    const firstChar = username.charAt(0); // 获取第一个字符  
    const lastChar = username.charAt(username.length - 1); // 获取最后一个字符  
    const middleChars = username.slice(1, -1); // 获取中间的所有字符  
      
    // 使用*替换中间的所有字符  
    // const maskedName = firstChar + '*'.repeat(middleChars.length) + lastChar;  
    const maskedName = firstChar + '*' + lastChar;  
      
    return maskedName;  
  }

  // 随机获取指定数量的投票信息（假数据）
  getVoteDataRandom = (num = 10) => {
    const { baseConfig = {}, itemList = [] } = this.props.config; 
    const ids = [];
    itemList.forEach((item, index) => {
      if (item.id) {
        ids.push(item.id)
      } else {
        ids.push(index === 0 ? 1 : 2);
      }
    });

    let staticUsers = getStaticUsers();
    staticUsers = staticUsers.sort(() => Math.random() - 0.5).slice(0, num);
    staticUsers = staticUsers.map((item, index) => {
      const randomIdx = Math.floor(Math.random() * ids.length);  
      const randomVal = ids[randomIdx];
      const temp = {
        id: item.id,
        special_id: this.pageId,
        vote_name: this.voteName,
        vote_id: randomVal,
        user_name: item.name,
        avatar: item.avatar,
        client_str: "",
        create_at: "",
        update_at: ""
      }
      return temp;
    });
    return staticUsers;
  }

  renderSenceType() {
    const { baseConfig = {}, itemList = [] } = this.props.config;
    const { pkData, userHasVote } = this.state;
    return (
      <Fragment>
        <p
          className="title"
          style={{
            backgroundColor: hexColorToRgba(this.props.backgroundColor, 0.4),
            color: baseConfig.backgroundColor === '深色' ? '#FFF' : '#000'
          }}
        >
          {baseConfig.title.slice(0, 17)}
        </p>
        { this.renderSupportList() }
        <div className="pk-area">
          <div className="pk-content left" onClick={this.handleItemClick.bind(this, 'left', 0)}>
            <img src="https://static.shihuocdn.cn/admin/files/20240124/f543d6ecce154eccf718ede9c1aabc75.png" alt="" className="gradient-img" />
            { itemList[0] && itemList[0].img && <img src={itemList[0].img} alt="红方图片" className="product-img" /> }
            <p className="name">{itemList[0] ? itemList[0].name || '红方' : '红方'}</p>
            {
              userHasVote 
                && pkData.left.hasVote 
                  && <img src="https://static.shihuocdn.cn/admin/files/20240124/8da25070c6e478d8d163fbc4984b919c.png" alt="" className="vote-icon" />
            }
          </div>
          <div className="pk-content right" onClick={this.handleItemClick.bind(this, 'right', 1)}>
            <img src="https://static.shihuocdn.cn/admin/files/20240124/06f163b9633900a8a6093bacedd93257.png" alt="" className="gradient-img" />
            { itemList[1] && itemList[1].img && <img src={itemList[1].img} alt="蓝方图片" className="product-img" /> }
            <p className="name">{itemList[1] ? itemList[1].name || '蓝方' : '蓝方'}</p>
            {
              userHasVote 
                && pkData.right.hasVote 
                  && <img src="https://static.shihuocdn.cn/admin/files/20240124/45a0841742a0587598c9ff127ca2ab4b.png" alt="" className="vote-icon" />
            }
          </div>
          <img src="https://static.shihuocdn.cn/admin/files/20231228/a3887e5b94b9fc2611c75fbe0ff8ec75.png" alt="" className="pk-logo" />
        </div>
      </Fragment>
    )
  }

  renderLogoType() {
    const { baseConfig = {}, itemList = [] } = this.props.config;
    const { pkData, userHasVote } = this.state;
    return (
      <Fragment>
        <p
          className="title"
          style={{
            backgroundColor: hexColorToRgba(this.props.backgroundColor, 0.4),
            color:  baseConfig.backgroundColor === '深色' ? '#FFF' : '#000'
          }}
        >
          {baseConfig.title.slice(0, 17)}
        </p>
        { this.renderSupportList() }
        <div className="pk-area">
          <div className="pk-content left" onClick={this.handleItemClick.bind(this, 'left', 0)}>
            <div className="content-wrap">
              <img src="https://static.shihuocdn.cn/admin/files/20240124/a34ea34f9d4a720545c21583c6b9c3c6.png" alt="" className="gradient-img" />
              { itemList[0] && itemList[0].img && <img src={itemList[0].img} alt="红方Logo" className="product-img" /> }
              <p className="name" style={{color:  baseConfig.backgroundColor === '深色' ? '#FFF' : '#000'}}>{itemList[0] ? itemList[0].name || '红方' : '红方'}</p>
            </div>
            {
              userHasVote 
                && pkData.left.hasVote 
                  && <img src="https://static.shihuocdn.cn/admin/files/20240124/8da25070c6e478d8d163fbc4984b919c.png" alt="" className="vote-icon" />
            }
          </div>
          <div className="pk-content right" onClick={this.handleItemClick.bind(this, 'right', 1)}>
            <div className="content-wrap">
              <img src="https://static.shihuocdn.cn/admin/files/20240124/ccaddc02462320461715c5773b104a9a.png" alt="" className="gradient-img" />
              { itemList[1] && itemList[1].img && <img src={itemList[1].img} alt="蓝方Logo" className="product-img" /> }
              <p className="name" style={{color:  baseConfig.backgroundColor === '深色' ? '#FFF' : '#000'}}>{itemList[1] ? itemList[1].name || '蓝方' : '蓝方'}</p>
            </div>
            {
              userHasVote 
                && pkData.right.hasVote 
                  && <img src="https://static.shihuocdn.cn/admin/files/20240124/45a0841742a0587598c9ff127ca2ab4b.png" alt="" className="vote-icon" />
            }
          </div>
          <img src="https://static.shihuocdn.cn/admin/files/20231228/a3887e5b94b9fc2611c75fbe0ff8ec75.png" alt="" className="pk-logo" />
        </div>
      </Fragment>
    )
  }

  renderSupportList() {
    const { baseConfig = {} } = this.props.config;
    return (
      <div
        className="support-list swiper-no-swiping"
        ref={ref => this.voteSwiperRef = ref}
        style={{
          color: baseConfig.backgroundColor === '深色' ? '#CACACA' : '#000'
        }}
      >
        <div className="swiper-wrapper">
          {this.state.voteUserList.map((item, index) => {
            return (
              <div className="support-item swiper-slide" key={item.id} style={{backgroundColor: baseConfig.backgroundColor === '深色' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(255, 255, 255, 0.8)',}}>
                <img className="user-avatar" src={utils.formatImgUrl(item.avatar, this.props.webpSupport)} alt="" />
                <div className="vote-content">
                  {item.user_name}投给了{item.vote_name}
                </div>
              </div>
            )
          })}
        </div>
        <div className="swiper-pagination"></div>
      </div>
    )
  }

  render() {
    const { baseConfig } = this.props.config;
    const { pkData, userHasVote, voteSide, compShow } = this.state;
    return (
      <div
        className={`pipeline-pkRank ${baseConfig.pkType === 'logo' ? 'logo-type' : 'sence-type'} ${baseConfig.backgroundColor === '深色' ? 'bg-black' : 'bg-white'}`}
        id={this.props['customAttributes']['data-component-id']}
        name={baseConfig.title}
        {...this.props['customAttributes']}
        style={{
          paddingTop: baseConfig.moduleMarginTop >= 0 ? `${baseConfig.moduleMarginTop}px` : 0,
          marginTop: baseConfig.moduleMarginTop < 0 ? `${baseConfig.moduleMarginTop}px` : 0,
          marginBottom: this.props.showCompMarginBottom ? '8px' : '0px',
          visibility: compShow ? 'visible' :'hidden'
        }}
      >
        {
          baseConfig.pkType === 'logo'
            ? this.renderLogoType()
            : this.renderSenceType()
        }
        <div className="contrast">
          <div className="progress left" ref={ref => this.progressLeftRef = ref}></div>
          <div className="progress right" ref={ref => this.progressRightRef = ref}></div>
        </div>
        {
          userHasVote && (
            <div className="vote-result">
              <div className="result-left">
                <p className="number">{pkData.left.voteCount}票</p>
              </div>
              <div className="result-right">
                <p className="number">{pkData.right.voteCount}票</p>
              </div>
            </div>
          )
        }
        {
          !userHasVote && (
            <div className="vote-btns">
              <img 
                src={
                  baseConfig.backgroundColor === '深色' 
                    ? 'https://static.shihuocdn.cn/admin/files/20240123/8123b1056835d0b42b7de6429fdbc9f8.png'
                    : 'https://static.shihuocdn.cn/admin/files/20240105/a7d8e7f3826dcc14e8d924ad3247abf9.png'
                }
                alt=""
                className="btn left"
                onClick={this.handleVoteAction.bind(this, 'left')}
              />
              <img
                src={
                  baseConfig.backgroundColor === '深色'
                    ? 'https://static.shihuocdn.cn/admin/files/20240123/b7c015091bea97072845f747ecadaaf1.png'
                    : 'https://static.shihuocdn.cn/admin/files/20240105/982eb92d823430c496a0939b3cd943c7.png'
                }
                alt=""
                className="btn right"
                onClick={this.handleVoteAction.bind(this, 'right')}
              />
            </div>
          )
        }
        {
          !userHasVote && <p className="not-vote-tip" style={{color: baseConfig.backgroundColor === '深色' ? '#fff' : '#333'}}>投票后可查看结果</p>
        }
        {
          userHasVote && <p className="thanks" style={{color: baseConfig.backgroundColor === '深色' ? '#fff' : '#333'}}>感谢你的参与！</p>
        }
        <div id="praise" className={voteSide} ref={ref => this.praiseRef = ref}></div>
      </div>
    );
  }
}

PipelinePkRank.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelinePkRank };
export default PipelinePkRank;



// WEBPACK FOOTER //
// ./components/pipeline-pkRank/index.js